import { patchState, signalStore, withComputed, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { type IncidentStatuses } from '../../../../core/types/incident-statuses.type';
import { computed, inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { IncidentStatusesService } from './incident-statuses.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { setError, withCallState, withReset } from '@ngrx-toolkit/core';
import { AuthStore } from '../../../../core';

type State = {
  statuses: IncidentStatuses;
};

const initialState: State = {
  statuses: {
    paymentStatus: null,
    pleaSubmitted: null,
  },
};

export const IncidentStatusesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withReset(),
  withCallState(),
  withComputed(({ statuses }) => ({
    pleaSubmitted: computed(() => statuses().pleaSubmitted),
    paymentStatus: computed(() => statuses().paymentStatus),
  })),
  withProps(({ statuses }) => ({
    statuses$: toObservable(statuses),
    paymentStatus$: toObservable(statuses.paymentStatus),
  })),
  withMethods((store, api = inject(IncidentStatusesService)) => ({
    load: rxMethod<void>(
      pipe(
        switchMap(() =>
          api.load().pipe(
            tapResponse({
              next: (statuses) => patchState(store, { statuses }),
              error: (error) => patchState(store, setError(error)),
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit(store, authStore = inject(AuthStore)) {
      authStore.logout$.subscribe(() => store.resetState());
    },
  }),
);
